import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setError, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize, registerField } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'ANALITICA_IMPORTACAO_MES_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'ANALITICA_IMPORTACAO_MES_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('analiticaImportacaoMesForm', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/custoImportacaoMes/custosReceitas`);
    return {
        type: 'ANALITICA_IMPORTACAO_MES_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return async (dispatch, getState) => {

		dispatch(setAguardando(true));

		try {

			if (registro.id_tipo == 'custo') {				
				await importarCustos({
					...registro,
					id_usuario_inclusao: getState().auth.usuario.id,
					id_usuario_alteracao: getState().auth.usuario.id
				});

			} else if (registro.id_tipo == 'receita') {

				await importarReceitas({
					...registro,
					id_usuario_inclusao: getState().auth.usuario.id,
					id_usuario_alteracao: getState().auth.usuario.id
				});
				
			}
			dispatch(getLista());
			dispatch(setModoTela('lista'));

			setSuccess('Operação Realizada com sucesso.');

		} catch(ex) {
			setError('Erro ao realizar importação');
		}

		dispatch(setAguardando(false));

    };
}

async function importarCustos(registro) {

	let lista = [];
	let listaAnaliticoFolha = [];

	let listaTipos = [];
	await axios.get(`${consts.API_URL}/custoTipo`).then(result => {
		listaTipos = result.data;
	});

	const competenciaInicial = FormatUtils.formatarCompetenciaBanco(registro.competencia_inicial); //YYYYMM
	const competenciaFinal = FormatUtils.formatarCompetenciaBanco(registro.competencia_final); //YYYYMM

	for (var i = 0; i < registro.tabela.length; i++) {
		let item = registro.tabela[i];

		let data = item[8];

		let analitica = (item[4] || '').split('-')[0] ? (item[4] || '').split('-')[0].replace('Analítica:', '').trim() : null;
		console.log(analitica);
		

		if (data && analitica) {

			let tipo = listaTipos.filter(tipoCusto => (tipoCusto.analiticas || []).filter(idAnalitica => idAnalitica == analitica).length)[0];

			data.setHours(data.getHours() + 12);

			let valor = parseFloat(item[19]) || 0;
			// let valor = parseFloat(item[27]);

			if (data && valor && tipo) {
				let competencia = `${data.getFullYear()}${String(data.getMonth() + 1).padStart(2, '0')}`;

				//Início agrupado

				if (competencia && competencia >= competenciaInicial && competencia <= competenciaFinal) {

					if (!lista.filter(registro => registro.id_tipo == tipo.id && registro.competencia == competencia).length) {
						lista.push({
							id_tipo: tipo.id,
							id_unidade: registro.id_unidade,
							competencia: competencia,
							valor: 0,
							id_usuario_inclusao: registro.id_usuario_inclusao,
							id_usuario_alteracao: registro.id_usuario_alteracao
						});
					}

					lista = lista.map(registro => {
						if (registro.id_tipo == tipo.id && registro.competencia == competencia) {
							return {
								...registro,
								valor: registro.valor + valor
							};
						} else {
							return registro;
						}
					});
				} else {
					console.log(`Despesa fora da competência: ${competencia} >= ${competenciaInicial} && ${competencia} <= ${competenciaFinal} => ${valor}`);					
				}

				//Fim agrupado

				//Início analítico - folha

				if (tipo.id == 4) { //CUSTOS COM PESSOAL E TERCEIROS
					const registroFolha = {
						data_custo: `${data.getFullYear()}/${String(data.getMonth() + 1).padStart(2, '0')}/${String(data.getDate()).padStart(2, '0')}`,
						pessoa: (item[3] || '').replace('Historico: ADTO SALARIO', '').replace('Historico: MENSAL', '').replace('Historico: FERIAS', '').trim(),
						descricao: item[4],
						valor: valor
					};

					if (registroFolha.data_custo && registroFolha.pessoa && registroFolha.valor) {
						listaAnaliticoFolha.push(registroFolha);
					}
				}

				//Fim analítico - folha

			} else {
				// console.log(item[4], ' = ', item[19]);
			}
		} else {
			if (item[4] && item[19]) {
				// console.log(item[4], ' = ', item[19]);
			}
		}
	}

	await axios.post(`${consts.API_URL}/custoFolhaPessoaMes`, {
		lista: listaAnaliticoFolha
	}).then(resp => {
		console.log('Operação Realizada com sucesso.');
	}).catch(ex => {
		throw ex;
	});

	await axios.post(`${consts.API_URL}/custoImportacaoMes`, {
		lista: lista
	}).then(resp => {
	}).catch(ex => {
		throw ex;
	});

}

async function importarReceitas(registro) {

	let lista = [];

	let listaTipos = [];
	await axios.get(`${consts.API_URL}/receitaTipo`).then(result => {
		listaTipos = result.data;
	});

	const competenciaInicial = FormatUtils.formatarCompetenciaBanco(registro.competencia_inicial); //YYYYMM
	const competenciaFinal = FormatUtils.formatarCompetenciaBanco(registro.competencia_final); //YYYYMM

	for (var i = 0; i < registro.tabela.length; i++) {
		let item = registro.tabela[i];

		let data = item[15];

		if (data) {

			//No arquivo apenas vem receitas de fretes, nã vem anaítica nos itens 
			let tipo = listaTipos.filter(tipoReceita => tipoReceita.id == 1)[0]; //Receitas com frete

			data.setHours(data.getHours() + 12);

			let valor = parseFloat(item[27]) || 0;

			if (data && valor && tipo) {
				let competencia = `${data.getFullYear()}${String(data.getMonth() + 1).padStart(2, '0')}`;

				if (competencia && competencia >= competenciaInicial && competencia <= competenciaFinal) {

					if (!lista.filter(registro => registro.id_tipo == tipo.id && registro.competencia == competencia).length) {
						lista.push({
							id_tipo: tipo.id,
							id_unidade: registro.id_unidade,
							competencia: competencia,
							valor: 0,
							id_usuario_inclusao: registro.id_usuario_inclusao,
							id_usuario_alteracao: registro.id_usuario_alteracao
						});
					}

					lista = lista.map(registro => {
						if (registro.id_tipo == tipo.id && registro.competencia == competencia) {
							return {
								...registro,
								valor: registro.valor + valor
							};
						} else {
							return registro;
						}
					});
				} else {
					console.log(`Receita fora da competência: ${competencia} => ${valor}`);					
				}
			}
		}
	}

	await axios.post(`${consts.API_URL}/receitaImportacaoMes`, {
		lista: lista
	}).then(resp => {
	}).catch(ex => {
		throw ex;
	});

}

export function getListaUnidade() {
    const request = axios.get(`${consts.API_URL}/unidade/listarSelect`);
    return {
        type: 'ANALITICA_IMPORTACAO_MES_UNIDADE_SELECT_LISTADO',
        payload: request
    };
}
